import React, { useEffect, useContext } from 'react';

import {
    LinearProgress
} from '@material-ui/core';

import { RolesProvider, RolesContext } from './RolesContext';
import { NavContext } from '../../../contexts';

import {
    RoleList
} from './components';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    root: {
    }
});

const PageContent = () => {
    const { addBreadcrumbToken } = useContext(NavContext);
    
    const { 
        state,
        isLoadingRoles,
        getRolesAsync
    } = useContext(RolesContext);

    const {
        roles
    } = state;

    useEffect(() => {
        addBreadcrumbToken("Roles")
    }, []);

    useEffect(() => {
        getRolesAsync();
    }, [])

    return (
        <>            
            {isLoadingRoles &&
                <LinearProgress color="primary" />
            }        
            {roles && !isLoadingRoles &&
                <RoleList />                
            }
        </>        
    );
}

export const RolesPage = () => {
    return (
        <RolesProvider>           
            <PageContent /> 
        </RolesProvider>
    );
}
